/**
 * The pre-generated responsive variants, and which source each belongs to.
 *
 * Written out rather than derived from a glob so that a missing variant is a
 * type error at the call site instead of a `srcset` entry that 404s. There is
 * one image; a build step that scanned a directory would be more machinery than
 * the problem deserves.
 *
 * Regenerate with `node scripts/generate-image-variants.mjs` after changing the
 * source, and keep the widths here in step with the ones that script emits.
 */
export type ImageVariants = {
  /** Widths available, ascending. */
  widths: number[];
  /** Builds the path for one width. */
  path: (width: number) => string;
};

const VARIANTS: Record<string, ImageVariants> = {
  "/asetqu.png": {
    widths: [64, 128, 512, 1024],
    path: (width) => `/generated/asetqu-${width}.webp`,
  },
};

/**
 * The `src` and `srcSet` for one source image at one layout width.
 *
 * `srcSet` lists every variant with its intrinsic width and lets the browser
 * choose, which is what makes a 2x screen pick the 128px file for a 64px logo
 * without the markup having to know anything about device pixel ratios.
 *
 * An unknown source falls back to itself. That keeps the component usable for a
 * one-off image nobody has generated variants for, at the cost of serving the
 * original — which is visible in the network panel rather than silent.
 */
export function resolveImage(
  source: string,
  displayWidth: number,
): { src: string; srcSet?: string } {
  const variants = VARIANTS[source];
  if (!variants) return { src: source };

  const srcSet = variants.widths.map((width) => `${variants.path(width)} ${width}w`).join(", ");

  // The smallest variant that still covers the layout width, so a 64px logo
  // does not default to the 1024px file on a 1x screen.
  const fallback =
    variants.widths.find((width) => width >= displayWidth) ??
    variants.widths[variants.widths.length - 1]!;

  return { src: variants.path(fallback), srcSet };
}
